import { httpClient } from "@/shared/services/http";

export interface IInterviewQuestion {
  interviewQuestionId: number;
  body: string;
}

export class InterviewQuestionsHttpService {
  static async getInterviewQuestions(): Promise<IInterviewQuestion[]> {
    const { data } = await httpClient.get<IInterviewQuestion[]>("/api/interview-questions");
    return data;
  }

  static async createInterviewQuestion(body: string): Promise<IInterviewQuestion> {
    const { data } = await httpClient.post<IInterviewQuestion>("/api/interview-questions", { body });
    return data;
  }
}
